import React from "react";
import { Table } from "react-bootstrap";
import { ViewFilesRow } from "./ViewFilesRow";

interface ViewFilesState {
  docs: any;
  fetchDocuments: any;
  myCase: boolean;
  setIsLoading: any;
  type: string;
  setShowToast?: any;
  setToastText?: any;
  setToastBody?: any;
}

export const ViewFiles = ({ docs, fetchDocuments, myCase, setIsLoading, type, setShowToast, setToastText, setToastBody}: ViewFilesState) => {
  return (
    <Table striped className="border-0 mb-0">
      <colgroup>
        <col style={{ width: "50%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "20%" }} />
      </colgroup>
      <thead>
        <tr>
          <th>File Name</th>
          <th>Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody className="border-0">
        {docs?.map((d: any) => (
          <ViewFilesRow
            key={d.id}
            item={d}
            fetchDocuments={fetchDocuments}
            myCase={myCase}
            setIsLoading={setIsLoading}
            type={type}
            setShowToast={setShowToast}
            setToastText={setToastText}
            setToastBody={setToastBody}
          />
        ))}
      </tbody>
      <tfoot className="border-0">
        <tr>
          {/* s */}
          <td colSpan={12} className="footnote text-muted border-0">
            Pdfs and Images are Viewable
          </td>
        </tr>
      </tfoot>
    </Table>
  );
};
